import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type CustomBackHandler = ((path: string) => void) | null

interface HeaderState {
  customBackHandler: CustomBackHandler
}

const initialState: HeaderState = {
  customBackHandler: null,
}

const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setCustomBackHandler: (state, action: PayloadAction<CustomBackHandler>) => {
      state.customBackHandler = action.payload
    },
    clearCustomBackHandler: (state) => {
      state.customBackHandler = null
    },
  },
})

export const { setCustomBackHandler, clearCustomBackHandler } =
  headerSlice.actions
export default headerSlice.reducer
